import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = ({ color = designSystem.colors.neutral300, ...props }) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
            <Path
                d="M7.2998 3.5C8.41991 3.5 8.98038 3.49979 9.4082 3.71777C9.78446 3.90951 10.0905 4.21554 10.2822 4.5918C10.5002 5.01962 10.5 5.58009 10.5 6.7002V8.2998C10.5 9.41991 10.5002 9.98038 10.2822 10.4082C10.0905 10.7845 9.78446 11.0905 9.4082 11.2822C8.98038 11.5002 8.41991 11.5 7.2998 11.5H4.7002C3.58009 11.5 3.01962 11.5002 2.5918 11.2822C2.21554 11.0905 1.90951 10.7845 1.71777 10.4082C1.49979 9.98038 1.5 9.41991 1.5 8.2998V6.7002C1.5 5.58009 1.49979 5.01962 1.71777 4.5918C1.90951 4.21554 2.21554 3.90951 2.5918 3.71777C3.01962 3.49979 3.58009 3.5 4.7002 3.5H7.2998ZM5.375 6V9H6.625V6H5.375Z"
                fill={color}
            />
            <Path
                d="M6 1.125C7.03553 1.125 7.875 1.96447 7.875 3V4.375H4.125V3C4.125 1.96447 4.96447 1.125 6 1.125Z"
                stroke={color}
                strokeWidth="1.25"
            />
        </Svg>
    );
};

export default SvgComponent;
